import api from '@/services/api'

export default class PreferencesAPI {
  static PREFERENCES_ENDPOINT = 'preferences'
  /**
   * Initialize a `PreferencesAPI` instance.
   *
   * @param {class} cls  The class to use to create preference objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `PreferencesAPI`.
   *
   * @param {class} cls      The class to use to create preference objects.
   **/
  static create(cls) {
    return new PreferencesAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one preference from the API.
   *
   * @param {String} PreferenceID  Unique ID of the preference to retrieve.
   */
  get(PreferenceID) {
    const url = `${PreferencesAPI.PREFERENCES_ENDPOINT}/${PreferenceID}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Create one preference from the API.
   *
   * @param {String} PreferenceID  Unique ID of the preference to retrieve.
   */
  create(preference) {
    const url = `${PreferencesAPI.PREFERENCES_ENDPOINT}/`
    const data = this.cls.toAPI(preference)
    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
  }

  /**
   * Get all preferences through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${PreferencesAPI.PREFERENCES_ENDPOINT}/`
    const options = {
      params: {
        page_size: 999,
      },
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a preference through the API.
   *
   * @param {Preference} Preference data to send to the API.
   */
  update(preference, fields = [], excludeFields = []) {
    const url = `${PreferencesAPI.PREFERENCES_ENDPOINT}/${preference.id}/`
    const data = this.cls.toAPI(preference, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Update a preference through the API.
   *
   * @param {Preference} Preference data to send to the API.
   */
  delete(PreferenceID) {
    const url = `${PreferencesAPI.PREFERENCES_ENDPOINT}/${PreferenceID}/`
    return this.client.delete(url).then(response => response.data)
  }
}
